import { render } from "./mail.vue?vue&type=template&id=1cfeb4df&scoped=true"
import script from "./mail.vue?vue&type=script&lang=js"
export * from "./mail.vue?vue&type=script&lang=js"

import "./mail.vue?vue&type=style&index=0&id=1cfeb4df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfeb4df"]])

export default __exports__